import { Link } from "react-router-dom";
import "./style.scss";

const MenuButton = props => {
  return <Link to={props?.url || "/"}>{props.btnText}</Link>;
};

export default MenuButton;
